/**
 * Enum for RTC session failure types.
 * Based on JSSip failure causes and additional custom failure scenarios.
 */
export enum RtcFailureType {
  // Standard JSSip causes
  NO_ANSWER = 'NO_ANSWER',
  CANCELED = 'CANCELED',
  BUSY = 'BUSY',
  UNAVAILABLE = 'UNAVAILABLE',
  REQUEST_TIMEOUT = 'REQUEST_TIMEOUT',
  NO_ACK = 'NO_ACK',
  TRANSPORT_ERROR = 'TRANSPORT_ERROR',
  REJECTED = 'REJECTED',
  BYE = 'BYE',
  WEBRTC_ERROR = 'WEBRTC_ERROR',
  TERMINATED = 'TERMINATED',

  // Additional failure types from status codes
  SERVER_ERROR_500 = 'SERVER_ERROR_500',
  BUSY_EVERYWHERE_600 = 'BUSY_EVERYWHERE_600',

  // Media-related failures
  USER_MEDIA_FAILED = 'USER_MEDIA_FAILED',

  // Group category for user-facing call states
  USER_STATE_FAILURE = 'USER_STATE_FAILURE',

  // Generic/unknown failure
  UNKNOWN = 'UNKNOWN',
}
